import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { Card, Descriptions, Modal, Space, Spin, Table } from "antd";
import dayjs from "dayjs";
import * as React from "react";
import {
  AddonConfigDetail,
  TierConfigDetail,
  useGetAffiliateCampaignDetail,
} from "src/hooks/affiliate";

export type AffiliateCampaignDetailModalProps = {
  campaignCode: string;
};

const formatDateTime = (value?: string) =>
  value ? dayjs(value).format("DD/MM/YYYY HH:mm") : "-";

const tierColumns = [
  { title: "Tier Number", dataIndex: "tierNumber", key: "tierNumber", width: 160 },
  {
    title: "Commission Rate (%)",
    dataIndex: "commissionRate",
    key: "commissionRate",
    render: (v: number) => v?.toFixed(2),
  },
];

const addonColumns = [
  { title: "Addon Type", dataIndex: "addonType", key: "addonType", width: 200 },
  {
    title: "Min Value",
    dataIndex: "minValue",
    key: "minValue",
    render: (v?: number | null) => (v == null ? "-" : v),
  },
  {
    title: "Max Value",
    dataIndex: "maxValue",
    key: "maxValue",
    render: (v?: number | null) => (v == null ? "-" : v),
  },
  {
    title: "Limit/User (บาท/วัน)",
    dataIndex: "limitPerUser",
    key: "limitPerUser",
    render: (v?: number | null) => (v == null ? "-" : v),
  },
  {
    title: "Commission Rate (%)",
    dataIndex: "commissionRate",
    key: "commissionRate",
    render: (v: number) => v?.toFixed(2),
  },
];

export const AffiliateCampaignDetailModal = NiceModal.create(
  ({ ...props }: AffiliateCampaignDetailModalProps) => {
    const { visible, hide, remove } = useModal();
    const { data, isFetching } = useGetAffiliateCampaignDetail(props.campaignCode);

    return (
      <Modal
        centered
        width={1000}
        visible={visible}
        onCancel={hide}
        afterClose={remove}
        title={`Campaign: ${props.campaignCode}`}
        footer={null}
      >
        <Spin spinning={isFetching}>
          {data?.campaign && (
            <Space direction="vertical" size={16} style={{ width: "100%" }}>
              <Card title="ข้อมูล Campaign" size="small">
                <Descriptions column={2} bordered size="small">
                  <Descriptions.Item label="UID">{data.campaign.uid}</Descriptions.Item>
                  <Descriptions.Item label="Campaign Code">
                    {data.campaign.campaignCode}
                  </Descriptions.Item>
                  <Descriptions.Item label="ชื่อ">{data.campaign.campaignName}</Descriptions.Item>
                  <Descriptions.Item label="สถานะ">{data.campaign.status}</Descriptions.Item>
                  <Descriptions.Item label="Start Date">
                    {formatDateTime(data.campaign.startDate)}
                  </Descriptions.Item>
                  <Descriptions.Item label="End Date">
                    {formatDateTime(data.campaign.endDate)}
                  </Descriptions.Item>
                  <Descriptions.Item label="Commission Limit">
                    {data.campaign.commissionLimit ?? "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Active">
                    {data.campaign.isActive ? "Yes" : "No"}
                  </Descriptions.Item>
                  <Descriptions.Item label="คำอธิบาย" span={2}>
                    {data.campaign.description ? (
                      <div
                        style={{ maxHeight: 240, overflowY: "auto" }}
                        dangerouslySetInnerHTML={{ __html: data.campaign.description }}
                      />
                    ) : (
                      "-"
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item label="Created At">
                    {formatDateTime(data.campaign.createdAt)}
                  </Descriptions.Item>
                  <Descriptions.Item label="Updated At">
                    {formatDateTime(data.campaign.updatedAt)}
                  </Descriptions.Item>
                </Descriptions>
              </Card>

              <Card title="Tier Config" size="small">
                <Table<TierConfigDetail>
                  rowKey="uid"
                  columns={tierColumns}
                  dataSource={data.tierConfig || []}
                  pagination={false}
                  size="small"
                />
              </Card>

              <Card title="Addon Config" size="small">
                <Table<AddonConfigDetail>
                  rowKey="uid"
                  columns={addonColumns}
                  dataSource={data.addonConfig || []}
                  pagination={false}
                  size="small"
                />
              </Card>
            </Space>
          )}
        </Spin>
      </Modal>
    );
  },
);

export default AffiliateCampaignDetailModal;
